var e=(e,o)=>{const c=window.URL.createObjectURL(e),t=document.createElement("a");t.href=c,t.download=o,t.click(),window.URL.revokeObjectURL(c)};export{e as downloadFile};
//# sourceMappingURL=downloadFile.js.map